export const SIGN_IN = '/signin';
export const DASHBOARD_ROUTE = '/dashboard/*';
export const USER_SPECIFIC_ROUTE = '/dashboard/users/:id';
export const HOME_ROUTE = '/dashboard';
export const FINDINGS_ROUTE = '/findings';
export const FINDING_SPECIFIC_ROUTE = '/findings/:id';
export const DEFAULT_FINDINGS_ROUTE = '/findings?finding_status=OPEN';
export const WORKFLOW_ROUTE = '/workflow/*';
export const WORKFLOW_SPECIFIC_ROUTE = '/workflow/active-flows/:id';
export const POLICIES_ROUTE = '/policies';
export const DEFAULT_WORKFLOW_ROUTE = '/workflow';
export const ORG_DASHBOARD_ROUTE = `${HOME_ROUTE}/org`;
export const DEPT_DASHBOARD_ROUTE = `${HOME_ROUTE}/dept`;
export const USERS_DASHBOARD_ROUTE = `${HOME_ROUTE}/users`;
export const ACTIVE_WORKFLOWS_ROUTE = `${DEFAULT_WORKFLOW_ROUTE}/active-flows`;
export const ACTIONS_WORKFLOWS_ROUTE = `${DEFAULT_WORKFLOW_ROUTE}/actions`;
export const DEFAULT_ROUTE = '/';
export const NOT_FOUND_ROUTE = '*';
export const ORG_ROUTE = 'org';
export const DEPT_ROUTE = 'dept';
export const USERS_ROUTE = 'users';
export const ACTIVE_FLOWS_ROUTE = 'active-flows';
export const ACTIONS_ROUTE = 'actions';
export const PAGE_ROUTE = '/*';
export const SETTINGS_SPECIFIC_ROUTE = '/settings';
export const TOOLING_COVERAGE_ROUTE = '/coverage';
export const REDIRECT_ROUTE = '/auth/redirect';
export const INTEGRATIONS_ROUTE = '/policies/:cid';
export const TENANTS_ROUTE = '/auth/tenants';
export const CREATE_ENGAGEMENT_ROUTE = `${DEFAULT_WORKFLOW_ROUTE}/create-engagement/:id`;
export const CUSTOM_FINDINGS_ROUTE = '/policies/custom-findings';
export const CUSTOM_ACTIONS_DETAIL_ROUTE = `${DEFAULT_WORKFLOW_ROUTE}/actions/:id`;
export const TRAINING_SECURITY_TIPS_ROUTE = '/training/security-tips';
export const TRAINING_ANNUAL_COMPLIANCE_ROUTE = '/training/annual-compliance';
export const TRAINING_PHISHING_ROUTE = '/training/phishing';
export const VIDEO_PLAYER_ROUTE = '/assignment/video/:id';
export const TRAINING_BROWSER_COACHING_ROUTE = '/training/browser-coaching';
export const ENGAGEMENT_LOGS_ROUTE = `${DEFAULT_WORKFLOW_ROUTE}/engagement-logs/:id`;
export const ANALYTICS_DASHBOARD_ROUTE = '/analytics';
export const INVENTORY_ROUTE = '/inventory';
export const AGENTS_DASHBOARD_ROUTE = `${HOME_ROUTE}/agents`;
export const AGENTS_ROUTE = 'agents';
export const AGENT_DETAIL_ROUTE = '/agents/:id';
